import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetAllLogisticsVehiclesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.VehicleDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.VehicleDocumentSortInput> | Types.VehicleDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAllLogisticsVehiclesQuery = { __typename?: 'Query', logisticsVehicles?: { __typename?: 'LogisticsVehiclesConnection', totalCount: number, nodes?: Array<{ __typename?: 'VehicleDocument', id: string, tenantId: string, vehicleId: string, name: string, vehicleTypeId: string, carrierId?: string | null, licensePlate: string, ownership: Types.VehicleOwnership, hasLiftgate: boolean, isTempControlled: boolean, isActive: boolean, updatedAt: Types.TDateISO, updatedBy: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type LogisticsVehicleDocumentFieldsFragment = { __typename?: 'VehicleDocument', id: string, tenantId: string, vehicleId: string, name: string, vehicleTypeId: string, carrierId?: string | null, licensePlate: string, ownership: Types.VehicleOwnership, hasLiftgate: boolean, isTempControlled: boolean, isActive: boolean, updatedAt: Types.TDateISO, updatedBy: string };

export const LogisticsVehicleDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsVehicleDocumentFields on VehicleDocument {
  id
  tenantId
  vehicleId
  name
  vehicleTypeId
  carrierId
  licensePlate
  ownership
  hasLiftgate
  isTempControlled
  isActive
  updatedAt
  updatedBy
}
    `, {"fragmentName":"LogisticsVehicleDocumentFields"});
export const GetAllLogisticsVehiclesDocument = new TypedDocumentString(`
    query GetAllLogisticsVehicles($where: VehicleDocumentFilterInput, $order: [VehicleDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  logisticsVehicles(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...LogisticsVehicleDocumentFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment LogisticsVehicleDocumentFields on VehicleDocument {
  id
  tenantId
  vehicleId
  name
  vehicleTypeId
  carrierId
  licensePlate
  ownership
  hasLiftgate
  isTempControlled
  isActive
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetAllLogisticsVehicles: build.query<GetAllLogisticsVehiclesQuery, GetAllLogisticsVehiclesQueryVariables | void>({
      query: (variables) => ({ document: GetAllLogisticsVehiclesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetAllLogisticsVehiclesQuery, useLazyGetAllLogisticsVehiclesQuery } = injectedRtkApi;
